if (document.body.classList.contains("home") || document.body.classList.contains("top")) {
	const apiUrl: string = "https://graph.facebook.com/v14.0/";
	const igUserId: string = "17841454641059049";
	const accessToken: string =
		"EAAJUVdguvQwBAJDt2YeHxTzWx3iPANbyHXZBWw6XZApOQ7tW8BjQzM4jORWRICbuZCbPZB7I4bvrV5A28B6o43L7w9uU3qCh1CoKxgvPjBY3skgJgqbFm4c77QOoATYNT3VyZASuPTRznmCp40ZAYhwBkpy8LZAXC28PADLn6ZC0pGenAFhAb5EK";
	const hashId: string = "17943828716193197";

	document.addEventListener("DOMContentLoaded", () => {
		_getIgData();
		_getHashData();
	});

	// 公式Instagram
	function _getIgData(url = "") {
		const api =
			url ||
			`${apiUrl}${igUserId}/media?fields=caption,id,media_type,media_url&access_token=${accessToken}`;

		fetch(api)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				if (data.data !== undefined) {
					_putData01(data.data);
					if (data.paging !== undefined && data.paging.next !== undefined) {
						_getIgData(data.paging.next);
					}
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}

	function _putData01(media) {
		const igImg = <HTMLSourceElement>document.getElementById("ig-img");
		const igCaption = document.getElementById("ig-caption");

		igImg.src = media[0].media_url;
		igCaption.innerHTML = media[0].caption.replace(/\r?\n/g, "<br>");
	}

	// ハッシュタグ
	function _getHashData(url = "") {
		const api =
			url ||
			`${apiUrl}${hashId}/top_media?user_id=${igUserId}&fields=id,media_type,children{id,media_url,media_type},permalink,media_url&access_token=${accessToken}`;

		fetch(api)
			.then((response) => {
				return response.json();
				console.log(api)
			})
			.then((res) => {
				const data = res.data.slice(0, 9);
				data.forEach((mediaData, index) => {
					if (mediaData.media_type === "IMAGE") {
						_createImageTag(data, url === "" ? true : false);
						function _createImageTag(media, insert) {
							const igHashImg = document.querySelector(".hashtag-wrapper");
							const fragment = document.createDocumentFragment();
							const list = document.createElement("li");
							const link = document.createElement("a");
							list.classList.add(
								"w-[calc((100%_-_30px_)_/_3)]",
								"tab_px:w-[calc((100%_-_61px_)_/_3)]",
								"pc_px:w-[198.75px]",
								"list-hash"
							);
							const setLink = link.setAttribute("href", media[index].permalink);
							setLink;
							link.setAttribute("target", "_blank");
							fragment.appendChild(list);
							list.appendChild(link);

							const figure = document.createElement("figure");
							const img = document.createElement("img");
							img.src = media[index].media_url;
							img.classList.add("aspect-square", "object-cover", "hover-opacity-img", "w-full");
							img.setAttribute("width", "1440");
							img.setAttribute("height", "1440");
							img.setAttribute("loading", "lazy");
							link.appendChild(figure);
							figure.appendChild(img);

							if (insert) {
								igHashImg.insertBefore(fragment, null);
							} else {
								igHashImg.appendChild(fragment);
							}
						}
					}
					else if (mediaData.media_type === "CAROUSEL_ALBUM") {
						_createCarouselTag(data, url === "" ? true : false);
						function _createCarouselTag(media, insert) {
							const igHashImg = document.querySelector(".hashtag-wrapper");
							const fragment = document.createDocumentFragment();
							const list = document.createElement("li");
							const link = document.createElement("a");
							list.classList.add(
								"w-[calc((100%_-_30px_)_/_3)]",
								"tab_px:w-[calc((100%_-_61px_)_/_3)]",
								"pc_px:w-[198.75px]",
								"list-hash"
							);
							const setLink = link.setAttribute("href", media[index].permalink);
							setLink;
							link.setAttribute("target", "_blank");
							fragment.appendChild(list);
							list.appendChild(link);

							const figure = document.createElement("figure");
							const img = document.createElement("img");

							img.src = mediaData.children.data[0].media_url;
							img.classList.add("aspect-square", "object-cover", "hover-opacity-img", "w-full");
							img.setAttribute("width", "1440");
							img.setAttribute("height", "1440");
							img.setAttribute("loading", "lazy");
							link.appendChild(figure);
							figure.appendChild(img);

							if (insert) {
								igHashImg.insertBefore(fragment, null);
							} else {
								igHashImg.appendChild(fragment);
							}
						}
					}
					else if (mediaData.media_type === "VIDEO") {
						_createVideoTag(data, url === "" ? true : false);
						function _createVideoTag(media, insert) {
							const igHashImg = document.querySelector(".hashtag-wrapper");
							const fragment = document.createDocumentFragment();
							const list = document.createElement("li");
							const link = document.createElement("a");
							list.classList.add(
								"w-[calc((100%_-_30px_)_/_3)]",
								"tab_px:w-[calc((100%_-_61px_)_/_3)]",
								"pc_px:w-[198.75px]",
								"list-hash"
							);
							const setLink = link.setAttribute("href", media[index].permalink);
							setLink;
							link.setAttribute("target", "_blank");
							fragment.appendChild(list);
							list.appendChild(link);

							const video = document.createElement("video");
							const source = document.createElement("source");

							source.src = media[index].media_url + "#t=0.001";

							video.classList.add("aspect-square", "object-cover", "hover-opacity-img", "w-full");
							video.setAttribute("width", "1440");
							video.setAttribute("height", "1440");
							link.appendChild(video);
							video.appendChild(source);
							video.setAttribute("playsinline", "true");

							if (insert) {
								igHashImg.insertBefore(fragment, null);
							} else {
								igHashImg.appendChild(fragment);
							}

						}
					}
				});
			})
			.catch((error) => {
				console.log(error);
			});

	}


}
